import React from 'react';
import Client from '../../../models/Client';
import Pagination from '../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, Paper } from  '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow } from '../../Utils/ISTable';
import { useTranslation } from 'react-i18next';


export const clientStatus = ['1', '2', '3', '4', '5']

export type ClientStatus = typeof clientStatus[number]

export const clientStatusToDescription = (type: ClientStatus): string => {
  switch (type) {
    case '1': return "active"
    case '2': return "inactive"
    case '3': return "debtor"
    case '4': return "badDebt"
    case '5': return "other"
  }
  return "not"
}


export interface Row {
  data: Client
  action?: 'create' | 'update' | 'error';
}

interface Props {
  rows: Row[];
  loading: boolean;
  pagination?: Pagination;
  onChangePage?: (page: number) => void;
  onClickInfo?: (codigo_cliente: number) => void;
}

const Clients: React.FC<Props> = (props) => {  
  const { t } = useTranslation('client')

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }

  return (
    <Paper style={{borderRadius: "10px", margin:"10px"}}>
      <ISTableTitle title={t('title')}/> 
      <Table style={{whiteSpace:"nowrap", overflow:"hidden"}} size="medium" >
        <TableHead>
          <TableRow selected={true}>
            <ISTableHeaderCell align='center'>{t('code')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('name')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('fantasyName')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('documentId')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('address')}</ISTableHeaderCell>
            <ISTableHeaderCell align='center'>{t('zipCode')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('locality')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('state')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('vendor')}</ISTableHeaderCell>
            {/*<ISTableHeaderCell align='center'>{t('transport')}</ISTableHeaderCell>
            <ISTableHeaderCell align='center'>{t('payCond')}</ISTableHeaderCell>*/}
            <ISTableHeaderCell align='center'>{t('estado')}</ISTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { !props.loading && props.rows.map((row, index) =>
            <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{cursor: 'pointer'}}
                  onClick={(e) => { e.stopPropagation(); props.onClickInfo && props.onClickInfo(row.data.codigo_cliente) }}>
              <TableCell align='center'>{row.data.codigo_cliente}</TableCell>
              <TableCell>{row.data.nombre}</TableCell>
              <TableCell>{row.data.nombrefantasia}</TableCell>
              <TableCell>{row.data.cuit}</TableCell>
              <TableCell>{row.data.domicilio}</TableCell>
              <TableCell align='center'>{row.data.codigopostal}</TableCell>
              <TableCell>{row.data.localidad}</TableCell>
              <TableCell>{row.data.provincia}</TableCell>
              <TableCell>{row.data.vendedor}</TableCell>
              {/*<TableCell align='center'>{row.data.codigo_transporte}</TableCell>
              <TableCell align='center'>{row.data.codigo_condicion_de_pago_ventas}</TableCell>*/}
              <TableCell align='center'>{t(clientStatusToDescription(row.data.estado.toString()))}</TableCell>
            </ISTableRow>
          )}
        </TableBody>
      </Table>
      { props.loading &&
        <div style={{display:'flex', justifyContent:'center'}}>
          <CircularProgress size={25} />
        </div>
      }
      <PaginationButtons pagination={props.pagination} />
    </Paper>
  );
}

export default Clients

